// composables/useTransform.ts
import type { GtagItem } from '~/types/transform'

export function useTransform() {
  function transGtagItemsFromOrder(order: any): GtagItem[] {
    return (order.product_items || []).map((item: any, index: number) => {
      const product = item.artwork_product_id?.product_id
      const artwork = item.artwork_product_id?.artwork_id

      const brandOption = product?.product_option_product?.find(
        (opt: any) => opt.option_id?.product_option_group_id?.name_en === 'Brand'
      )
      const modelOption = product?.product_option_product?.find(
        (opt: any) => opt.option_id?.product_option_group_id?.name_en === 'Model'
      )

      const artworkName = artwork?.name_th || artwork?.name_en
      const productName = product?.display_name_th || product?.display_name_en

      return {
        item_id: product?.sku || artwork?.sku || item.id,
        item_name: artworkName || productName || 'Unnamed Product',
        artwork_name: artworkName,
        product_name: productName,
        artwork_sku: artwork?.sku,
        product_sku: product?.sku,
        affiliation: order.pickup_location?.name || 'Online Store',
        coupon: order.voucher_code || undefined,
        discount: parseFloat(order.discount_price || '0'),
        index,
        item_brand: brandOption?.option_id?.name_en || undefined,
        item_category: product?.type || undefined,
        item_variant: modelOption?.option_id?.name_en || undefined,
        location_id: order.pickup_location_id || undefined,
        price: parseFloat(item.price || '0'),
        quantity: item.amount || 1
      }
    })
  }

  function transGtagPurchase(order: any) {
    return {
      transaction_id: order.order_number,
      value: parseFloat(order.total_price || '0'),
      tax: 0,
      shipping: parseFloat(order.shipping_price || '0'),
      currency: 'THB',
      coupon: order.voucher_code || undefined,
      items: transGtagItemsFromOrder(order)
    }
  }

  return {
    transGtagItemsFromOrder,
    transGtagPurchase
  }
}
